module.exports = __webpack_public_path__ + "img/hr-tree-01-g-trunk.22d34c14.png";